import { MediaStatus, MediaType } from '../../graphql';

export interface Media {
  id: string;
  name?: string;
  type: MediaType;
  extension: string;
  status: MediaStatus;
  url?: string;
  localUrl?: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: { id: string; name: { first: string; last: string } };
  categories?: { id: string; name: string }[];
}
